// extracted by mini-css-extract-plugin
module.exports = {"button":"hero-button_button__7b2IQ","appearWithDelay":"hero-button_appearWithDelay__IxJ9I","bold":"hero-button_bold__xPbSg","dark":"hero-button_dark__Fpb6_"};